export const sleep = (ms: number = 5000) => {
  return new Promise(function (resolve) {
    setTimeout(resolve, ms);
  });
};
